module.exports = __webpack_public_path__ + "static/media/spades_K.ad38662f.png";